import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { VomitingOrRegurgitationAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-vomiting-or-regurgitation-slot',
    templateUrl: './vomiting-or-regurgitation-slot.component.html',
    styleUrl: './vomiting-or-regurgitation-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VomitingOrRegurgitationSlotComponent implements SheetSlotComponentBase {

	@Input() action!: VomitingOrRegurgitationAction;
	value = null;

	constructor() {
	}
}